/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * check if an array contains strings only
 *
 * @param array - array
 * @returns true if array contains only strings, false otherwise
 * @deprecated will remove in v10
 */
function doesContainOnlyStrings(array) {
    return array.every((i) => typeof i === 'string');
}
/**
 * Sort objects inside an array
 *
 * @param a - first object
 * @param b - second object
 * @returns compares the id property of the two objects using standard comparison logic
 * @deprecated will remove in v10
 */
function compareById(a, b) {
    const itemA = a.id;
    const itemB = b.id;
    let comparison = 0;
    if (itemA > itemB) {
        comparison = 1;
    }
    else if (itemA < itemB) {
        comparison = -1;
    }
    return comparison;
}
/**
 * Convert a given date and time string to full date
 *
 * @param date - date and time string
 * @returns the number of milliseconds between 1 January 1970 00:00:00 UTC and the given date.
 * @deprecated will remove in v10
 */
function convertDateTimeToTimestamp(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate()).valueOf();
}
/**
 * find an object inside an array with a key
 *
 * @param objArray - array of objects
 * @param key - key of the object you want to use for the comparison
 * @param matchValue - value of the key you want to match
 * @returns The object within the `objArray` whose value for its `key` property matches the `matchValue`, or
 * `null` if no match is made.
 * @deprecated will remove in v10
 */
function findObjWithKey(objArray, key, matchValue) {
    return objArray.find((v) => v[key] === matchValue);
}
/**
 * Tests if an object is null
 *
 * @param obj - object to test
 * @returns true if null, false otherwise
 * @deprecated will remove in v10
 */
function isNull(obj) {
    return obj === null;
}
/**
 * Tests if an object is null
 *
 * @param obj - object to test
 * @returns false if null, true otherwise
 * @deprecated will remove in v10
 */
function isNotNull(obj) {
    return !isNull(obj);
}
/**
 * Tests if an object is undefined.
 *
 * @param obj - object to test
 * @returns true if undefined, false otherwise
 * @deprecated will remove in v10
 */
function isUndefined(obj) {
    return obj === undefined;
}
/**
 * Tests if an object is null or undefined.
 *
 * @param obj - object to test
 * @returns true if null or undefined, false otherwise
 * @deprecated will remove in v10
 */
function isNullOrUndefined(obj) {
    return isUndefined(obj) || isNull(obj);
}
/**
 * Tests if an object is null or undefined.
 *
 * @param obj - object to test
 * @returns false if null or undefined, true otherwise
 * @deprecated will remove in v10
 */
function isNotNullOrUndefined(obj) {
    return !isNullOrUndefined(obj);
}
/**
 * checks if item is an object
 *
 * @param item - element
 * @returns true if item is an object, false otherwise
 * @deprecated will remove in v10
 */
function isObject(item) {
    return !!item && item.constructor === Object;
}
/**
 * Return new array of elements that consist of all elements from array1 that don't exist in array2
 *
 * @param array1 - first array
 * @param array2 - second array
 * @returns array with elements from array1 that don't exist in array2
 * @deprecated will remove in v10
 */
function removeIntersection(array1, array2) {
    return array1.filter((element) => array2.indexOf(element) === -1);
}
/**
 * Removes matching items from an array
 *
 * @param item - object that is used to find a match
 * @param array - the array with all of the items
 * @deprecated will remove in v10
 */
function removeItemFromArray(item, array) {
    if (isNullOrUndefined(array)) {
        return;
    }
    for (let i = array.length - 1; i >= 0; --i) {
        if (array[i] === item) {
            array.splice(i, 1);
        }
    }
}
/**
 * Given a route segment, remove the leading slash and query parameters, if present, and return the result.
 *
 * @param routeSegment - Route segment
 * @returns the route by itself, without any leading slash or query parameters
 * @deprecated will remove in v10
 */
function getCoreRoute(routeSegment) {
    let coreRoute = removeLeadingSlash(routeSegment);
    coreRoute = removeQueryParams(coreRoute);
    return coreRoute;
}
/**
 * Given a route segment, remove the leading slash, if present, and return the result.
 *
 * @param routeSegment - Route segment
 * @returns a route without any leading slash
 * @deprecated will remove in v10
 */
function removeLeadingSlash(routeSegment) {
    return routeSegment ? routeSegment.replace(/^\//g, '') : routeSegment;
}
/**
 * Given a route segment, remove query parameters, if present, and return the result.
 *
 * @param routeSegment - Route segment
 * @returns a route without any query parameters
 * @deprecated will remove in v10
 */
function removeQueryParams(routeSegment) {
    return routeSegment ? routeSegment.split('?')[0] : routeSegment;
}
/**
 * As a substitute for String.prototype.replaceAll(), when your browser does not support replaceAll()
 * use of RegExp when your replaceFrom might contain special characters
 *
 * @param content - string
 * @param replaceFrom - string that is used to match content
 * @param replaceTo - string that is going to replace the match content
 * @returns string with replaced content
 * @deprecated will remove in v10
 */
function replaceAll(content, replaceFrom, replaceTo) {
    const output = content.split(replaceTo).join(replaceFrom);
    return output.replace(new RegExp(replaceFrom.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'), 'g'), replaceTo);
}
/**
 * Compares two lists for matching items. Can check for a single match, or if all items match based on matchAll
 * parameter
 *
 * @param listA - list of type any
 * @param listB - list of type any
 * @param matchAll - if true, check if all elements in both arrays match
 * @returns true if there is a match in both lists
 * @deprecated will remove in v10
 */
function inArray(listA, listB, matchAll = false) {
    const isMatch = (item) => listB.includes(item);
    return matchAll ? listA.every(isMatch) : listA.some(isMatch);
}

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { compareById, convertDateTimeToTimestamp, doesContainOnlyStrings, findObjWithKey, getCoreRoute, inArray, isNotNull, isNotNullOrUndefined, isNull, isNullOrUndefined, isObject, isUndefined, removeIntersection, removeItemFromArray, removeLeadingSlash, removeQueryParams, replaceAll };
